import { useHandleEscapeKey } from 'hooks'
import { Box } from 'theme-ui'
import { DCProgressInput } from 'components/Form'
import { Heading } from 'components'
import { Label } from 'components/Form'
import { DCProgressProps } from 'types'
import { mapProgressFromObj } from 'utils/dc'

export const DCProgressModal = ({
  name,
  dcProgress,
  set,
  cancel,
}: {
  name: string
  dcProgress?: any
  set: (lesson: DCProgressProps | undefined) => void
  cancel: () => void
}) => {
  useHandleEscapeKey(cancel)

  const currentProgress =
    mapProgressFromObj(dcProgress, 'long') ?? 'Not started'

  return (
    <div style={{ textAlign: 'justify', lineHeight: 1.6 }}>
      <Heading variant="forms.h1" sx={{ textAlign: 'left', mb: 20 }}>
        Adjust Digital Course position
      </Heading>
      <Box sx={{ color: '#727B89', mb: 20 }}>
        Current position: {currentProgress}
      </Box>
      <Label sx={{ fontWeight: 600 }}>Set Digital Course position to:</Label>
      <Box sx={{}}>
        <DCProgressInput
          name={name}
          onChange={set}
          options={progressList}
          placeholder={`Please select a lesson to start your student on`}
        />
      </Box>
    </div>
  )
}

const progressList = [
  {
    displayName: 'Day 1 (Session 1, Lesson 1)',
    lessonNumber: 1,
  },
  {
    displayName: 'Day 2 (Session 2, Lesson 2)',
    lessonNumber: 2,
  },
  {
    displayName: 'Day 2 (Session 2, Lesson 3)',
    lessonNumber: 3,
  },
  {
    displayName: 'Day 3 (Session 3, Lesson 4)',
    lessonNumber: 4,
  },
  {
    displayName: 'Day 3 (Session 3, Lesson 5)',
    lessonNumber: 5,
  },
  {
    displayName: 'Day 3 (Session 3, Lesson 6)',
    lessonNumber: 6,
  },
  {
    displayName: 'Day 10 (Session 4, Lesson 7)',
    lessonNumber: 7,
  },
  {
    displayName: 'Day 10 (Session 4, Lesson 8)',
    lessonNumber: 8,
  },
  {
    displayName: 'Course Complete',
    lessonNumber: 9,
  },
]
